module.exports = __webpack_public_path__ + "img/mrt_x_vision.64870c00.jpg";